import { LayoutDashboard } from 'lucide-react';

type AddAppButtonProps = {
  onClick: () => void;
};

export const AddAppButton = ({ onClick }: AddAppButtonProps) => {
  return (
    <button
      type='button'
      className='flex min-h-[40vh] flex-col gap-2 rounded-xl border border-dashed border-border bg-card p-0 text-card-foreground transition-colors hover:bg-muted'
      onClick={onClick}
    >
      <span className='flex h-12 w-28 items-center justify-center border-b-2 border-primary bg-muted font-medium'>
        Tab
      </span>
      <span className='flex flex-1 flex-col items-center justify-center gap-4'>
        <span className='flex size-16 items-center justify-center rounded-xl bg-muted text-muted-foreground'>
          <LayoutDashboard
            aria-hidden='true'
            className='size-6'
          />
        </span>
        <span className='text-sm text-muted-foreground'>Your app will appear here</span>
      </span>
    </button>
  );
};
